import { useContext, useMemo } from 'react';

import { AppContext } from '../context/app';
import type { Place } from '../context/types';
import { isGozioPlace, isSatellitePlace } from '../utils/typeGuards';
import { useKioskManager } from './useKioskManager';

export const useCampusComparison = (): any => {
  const { navStartingPlace, navDestinationPlace } = useContext(AppContext);
  const { kioskRegistration } = useKioskManager();

  const { isSameCampus, isDifferentCampus } = useMemo(() => {
    if (isSatellitePlace(navDestinationPlace)) {
      return { isSameCampus: false, isDifferentCampus: true };
    }
    if (
      navStartingPlace &&
      isGozioPlace(navStartingPlace) &&
      'location' in navStartingPlace &&
      navStartingPlace.location &&
      navDestinationPlace
    ) {
      const sameCampus =
        (navStartingPlace as Place).location.site ===
        navDestinationPlace.location.site;
      return { isSameCampus: sameCampus, isDifferentCampus: !sameCampus };
    }

    // when starting place is the kiosk location
    if (navStartingPlace && kioskRegistration) {
      return { isSameCampus: true, isDifferentCampus: false };
    }

    return { isSameCampus: false, isDifferentCampus: false };
  }, [kioskRegistration, navDestinationPlace, navStartingPlace]);

  return { isSameCampus, isDifferentCampus };
};
